import { render, staticRenderFns } from "./CustomMultiSelect.vue?vue&type=template&id=70997326&scoped=true"
import script from "./CustomMultiSelect.vue?vue&type=script&lang=js"
export * from "./CustomMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./CustomMultiSelect.vue?vue&type=style&index=0&id=70997326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70997326",
  null
  
)

export default component.exports